export class AsyncUtils {

  static sleep(timeout = 0) {
    return new Promise(resolve => setTimeout(resolve, timeout));
  }

  static await<T>(executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void,
                  timeout = 1000,
                  tries = 60) {
    return new Promise<T>((resolve, reject) => {
      const wrappedResolve: (value: T | PromiseLike<T>) => void = (value: T | PromiseLike<T>) => {
        clearInterval(timer);
        resolve(value);
      }
      const wrappedReject: (reason?: any) => void = (reason?) => {
        clearInterval(timer);
        reject(reason);
      }
      let calling = false;
      let triesLeft = tries;
      const timer = setInterval(async (): Promise<void> => {
        if (triesLeft < 1) {
          wrappedReject(`Timeout error after ${tries} tries`);
          return;
        }
        triesLeft--;
        if (calling) {
          return;
        }
        calling = true;
        try {
          executor(wrappedResolve, wrappedReject);
          calling = false;
        } catch (e) {
          wrappedReject(e);
        }
      }, timeout);
    });
  }

}
